import { Component, OnInit } from '@angular/core';
import { FuseConfigService } from '../../../../../core/services/config.service';
import { FuseTranslationLoaderService } from '../../../../../core/services/translation-loader.service';

import { locale as english } from '../../../../i18n/en';
import { locale as spanish } from '../../../../i18n/es';

@Component({
    selector   : 'fuse-error-401',
    templateUrl: './error-401.component.html',
    styleUrls  : ['./error-401.component.scss']
})
export class FuseError401Component implements OnInit
{
    constructor(
        private fuseConfig: FuseConfigService,
        private translationLoader: FuseTranslationLoaderService,
    )
    {
        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar   : 'none',
                footer    : 'none'
            }
        });

        // this.translationLoader.loadTranslations(english, spanish);
    }

    ngOnInit()
    {
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/errors/401/error-401.component.ts